import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import Layout from '../components/Layout';
import Head from '../components/Head';
import messages from '../lib/messages.json';
import ContactPageComponent from '../components/ContactPage';

const ContactPage: NextPageWithLayout = () => {
  const intl = useIntl();

  return (
    <>
      <Head
        title={intl.formatMessage(messages.contact)}
        description={intl.formatMessage(messages['messages.contact.description'])}
      />
      <ContactPageComponent />
    </>
  );
};

ContactPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default ContactPage;
